<template>
    <v-text-field
        :class="`edit-table-cell ${dense ? `dense` : ``}`"
        ref="input"
        :value="editValue" 
        @input="onValueChanged"
        type="number"
        autofocus
        single-line
        hide-details
        outline
        @blur="blur"
        @keydown.enter="enter"
        :rules="rules"
        :loading="loading"
        :disabled="loading">
        <template v-slot:append>
            <v-icon
                v-if="isDirty && !loading" 
                @click.stop="reset">
                undo
            </v-icon>
        </template>
    </v-text-field>
</template>

<script>
export default {
    components: {

    },
    props: {
        value: {
            type: String,
            required: true
        },
        rules: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            localValue: null
        };
    },
    computed: {
        editValue(){
            if(this.localValue != null){
                return this.localValue;
            }

            return this.value;
        },
        isDirty(){
            return this.editValue != this.value;
        }
    },
    methods: {
        reset(isEnter = false){
            this.localValue = null;
            this.$emit("close", isEnter);
        },
        onValueChanged(newValue){
            if(this.loading){
                return;
            }
            
            this.localValue = newValue;
        },
        blur() {
            this.submit(false);
        },
        enter() {
            this.submit(true);
        },
        submit(isEnter = false){
            if(this.loading){
                return;
            }

            this.$nextTick(() => {
                if(!this.isDirty){
                    this.reset(isEnter);
                } else if(this.$refs.input.validate()){
                    this.$emit("input", {value: this.localValue, isEnter: isEnter});
                }
            });
        }
    },
    created(){
        
    },
    mounted(){
        // Highlight all text
        let input = this.$refs.input.$refs.input;
        input.select();
    }
}
</script>

<style>
/* Chrome, Safari, Edge, Opera */
.edit-table-cell input::-webkit-outer-spin-button,
.edit-table-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


.edit-table-cell {
    font-size: 20px;
}

/* Firefox */
.edit-table-cell input[type=number] {
  -moz-appearance: textfield;
}

.edit-table-cell.dense .v-input__slot {
    min-height: 0px !important;
}

.edit-table-cell.dense input {
    margin-top: 0 !important;
    padding: 3px 0px;
}

.edit-table-cell.dense .v-input__append-inner {
    margin-top: 0 !important;
}
</style>